module.exports = __webpack_public_path__ + "img/plan-2-b9.d188c32b.png";